import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login.service';


export const AuthGuard: CanActivateFn = () => {
  return inject(LoginService).logado() ? true : inject(Router).createUrlTree(['/login']);
};
